import React from 'react'
import classNames from 'classnames'

const colorClasses = {
    green: 'border-[#9AD8BE] bg-[#ECFDF3] text-[#067647]',
    blue: 'border-[#9FCDE9] bg-[#ECF7FD] text-[#2F6DA3]',
    'dark-blue': 'border-[#9FCDE9] bg-[#2F6DA3] text-[#7EEAFF]',
    orange: 'border-[#F99257] bg-[#FFF2E1] text-[#F25400]',
    lightOrange: 'border-[#F99257] bg-[#FFF2E1] text-[#F99257]',
    red: 'border-[#F49598] bg-[#FDEAEA] text-[#E82B31]',
    pink: 'border-[#FAA3E4] bg-[#FDECFD] text-[#EB2AB5]',
    purple: 'border-[#9B5DE6] bg-[#EBE3F6] text-[#903FC0]',
    yellow: 'border-[#F7C93D] bg-[#FFF8E2] text-[#EB910B]',
    greyAndRed: 'border-[#8E8D8D] bg-[#F5F5F5] text-[#C03F41]',
    peach: 'border-[#EB8F73] bg-[#FDECEC] text-[#F72727]',
    grey: 'border-[#D0D5DD] bg-[#F5F5F5] text-[#989898]',
}

const StatusPill = ({
    label,
    color = 'blue',
    className,
    compactStyle = false,
    capitalize = false,
}) => {
    if (!label || label === 'no case') return null

    return (
        <span
            className={classNames(
                'inline-flex items-center whitespace-nowrap rounded-full border text-xs font-medium leading-none',
                compactStyle ? 'px-1.5 py-1' : 'px-2 py-[5px]',
                capitalize && 'capitalize',
                colorClasses[color] || colorClasses.blue,
                className,
            )}
        >
            {label}
        </span>
    )
}

export default StatusPill
